import { render, staticRenderFns } from "./QaToOfferGen.vue?vue&type=template&id=4983536e&scoped=true&"
import script from "./QaToOfferGen.vue?vue&type=script&lang=js&"
export * from "./QaToOfferGen.vue?vue&type=script&lang=js&"
import style0 from "./QaToOfferGen.vue?vue&type=style&index=0&id=4983536e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983536e",
  null
  
)

export default component.exports